import { render, staticRenderFns } from "./EmbedEditor.vue?vue&type=template&id=f5422cac&scoped=true&"
import script from "./EmbedEditor.vue?vue&type=script&lang=js&"
export * from "./EmbedEditor.vue?vue&type=script&lang=js&"
import style0 from "./EmbedEditor.vue?vue&type=style&index=0&id=f5422cac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5422cac",
  null
  
)

export default component.exports